import { action, computed, makeObservable, observable } from 'mobx';

export type WidgetState = {
  isDirty: boolean;
  validate: () => Promise<{ isValid: boolean; values?: Record<string, any> }>;
};

export type OnSaveParams = {
  widgetsFormData: { [key: string]: any };
};

export interface WidgetsFormProps {}

export class WidgetsFormState {
  _widgets = observable.map<string, WidgetState>(new Map());

  constructor() {
    makeObservable(this, {
      registerWidget: action.bound,
      isDirty: computed,
    });
  }

  registerWidget(key: string, state: WidgetState) {
    this._widgets.set(key, state);
  }

  async validate(): Promise<{ isValid: boolean; data: Record<string, any> }> {
    const data: Record<string, any> = {};
    let isValid = true;

    for (const [key, widget] of this._widgets.entries()) {
      const widgetData = await widget.validate();

      if (!widgetData.isValid) {
        isValid = false;
        return { isValid: false, data: {} };
      }

      data[key] = widgetData.values;
    }

    return { isValid, data };
  }

  get isDirty() {
    return [...this._widgets.values()].some((w) => w.isDirty);
  }

  get(key: string) {
    return this._widgets.get(key);
  }
}
